import * as React from 'react';
import { RootState } from '../../../store/index';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { TreeNodeType } from '../../../store/FMTree/FMTreeReducer';
import { getNodeData, isNodeChecked, makeIsNodeSelected } from '../../../store/FMTree/FMTReeSelectors';
import {
    ItemOwnProps,
    NodeStateProps,
    ItemProps,
} from '../../organisms/FMTree/TypesForNodes';

const FMTreeItemNodeWithStore = ItemNode => (props: ItemProps) => {

    let checkNode = () => props.checkNodeBase(
        props.treeType,
        props.treeDisplayState,
        TreeNodeType.item,
        props.id
    );

    let uncheckNode = () => props.uncheckNodeBase(
        props.treeType,
        props.treeDisplayState,
        TreeNodeType.item,
        props.id
    );

    let selectNode = () => props.selectNodeBase(
        props.treeDisplayState,
        TreeNodeType.item,
        props.id
    );

    return (
        <ItemNode
            {...props}
            checkNode={checkNode}
            uncheckNode={uncheckNode}
            selectNode={selectNode}
        />
    );
};

const mapStateToProps = (state: RootState, ownProps: ItemOwnProps): NodeStateProps => {

    const isNodeSelected = makeIsNodeSelected(TreeNodeType.item, ownProps.id);

    return {
        name: getNodeData(state, ownProps.treeType, ownProps.id, TreeNodeType.item).name,
        checked: isNodeChecked(state, ownProps.treeDisplayState, ownProps.id, TreeNodeType.item),
        selected: isNodeSelected(state, ownProps.treeDisplayState),
        nodeData: getNodeData(state, ownProps.treeType, ownProps.id, TreeNodeType.item)
    };

};

const ConnectedFMTreeGroupNode = compose(
    connect(mapStateToProps),
    FMTreeItemNodeWithStore
);

export default ConnectedFMTreeGroupNode;
